import { GET_INDICATOR_DATA_SUCCESS, FETCH_INDICATOR_DATA_REQUEST, GET_INDICATOR_DATA_FAILURE } from './actionTypes';
 
export const fetchIndicatorDataRequest = (payload: any) => ({
      type: FETCH_INDICATOR_DATA_REQUEST,
      payload
});

export const fetchIndicatorDataSuccess = (payload: any) => ({
      type: GET_INDICATOR_DATA_SUCCESS,
      payload
});

export const fetchIndicatorDataError = (payload: any) => ({
      type: GET_INDICATOR_DATA_FAILURE,
      payload
});